/* unplugin-vue-components disabled */import script from "./DarkThemeModeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DarkThemeModeSelector.vue?vue&type=script&setup=true&lang=js"

import "./DarkThemeModeSelector.vue?vue&type=style&index=0&id=76141422&scoped=true&lang=css"
import "./DarkThemeModeSelector.vue?vue&type=style&index=1&id=76141422&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76141422"]])

export default __exports__